import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { Link, withRouter } from "react-router-dom";
import io from "socket.io-client";
import moment from "moment-timezone";
import jwt_decode from "jwt-decode";

interface PropsInterface extends Type.ComponentInterface {
  event_id: number;
  token: string;
}

interface StateInterface {
  socket: any;
  message: string;
  messages: any[];
  status: string;
  room_id: number;
  jwt_user: any;
}

class EventShowPage extends React.Component<PropsInterface, StateInterface> {
  constructor(props: PropsInterface) {
    super(props);
    this.state = {
      socket: null,
      message: "",
      messages: [],
      status: "",
      room_id: 0,
      jwt_user: null,
    };
  }

  componentDidMount() {
    console.log("TRY TO CONNECT TO CHAT SERVER");
    this.setState({ jwt_user: jwt_decode(this.props.token) });
    const socket = io(process.env.API_URL_CHAT + "");
    socket.on("connected", () => {
      socket.emit("login", {
        token: this.props.token,
        type: "event",
        event_id: this.props.event_id,
      });
    });

    // socket.on("login", (data: { status: string }) => {
    //   this.setState({ status: data.status });
    //   socket.emit("join", {
    //     room: `broadcast-${this.props.broadcast_id}`,
    //   });
    // });

    socket.on("joined", (data: { room_id: number }) => {
      this.setState({ room_id: data.room_id });
      socket.emit("get-messages", { room_id: data.room_id });
    });

    socket.on("add-history", (data: any) => {
      const messages = data.messages.concat(this.state.messages);
      this.setState({ messages });
      setTimeout(() => {
        const element = document.getElementById("chat-messages");
        if (element !== null) {
          element.scrollTop = element.scrollHeight;
        }
      }, 100);
    });

    socket.on("new-message", (data: { user_name: string; message: string }) => {
      const messages = this.state.messages;
      messages.push(data);
      this.setState({ messages });
      setTimeout(() => {
        const element = document.getElementById("chat-messages");
        if (element !== null) {
          element.scrollTop = element.scrollHeight;
        }
      }, 100);
    });

    socket.on("message-deleted", ({ message_id }) => {
      let messages = [...this.state.messages];
      console.log("TRY TO REMOVE ", message_id);
      messages = messages.filter((message) => message.id !== message_id);
      console.log("AFTER REMOVING: ", messages);
      this.setState({ messages });
      setTimeout(() => {
        const element = document.getElementById("chat-messages");
        if (element !== null) {
          element.scrollTop = element.scrollHeight;
        }
      }, 100);
    });

    this.setState({ socket });
  }

  private deleteMessage(message_id: number) {
    this.state.socket.emit("delete-message", { message_id, room_id: this.state.room_id });
  }

  public render() {
    return (
      <>
        <div className="meeting__chat">
          <h3 className="meeting__chat-header">Сообщения</h3>
          <div className="meeting__chat-body">
            {/* <div className="meeting__message">Привет! Поговорим про сотрудничество?</div>
            <div className="meeting__message">
              <div className="meeting__card">
                <div className="meeting__card-name">Мария Митохина</div>
                <div className="meeting__card-position">Руководитель проектов Profi.Travel</div>
                <div className="meeting__card-contact">+7 499 254 71 41</div>
                <div className="meeting__card-contact">invest@dinaste.com</div>
                <div className="meeting__card-contact">dinaste.com</div>
                <div className="meeting__card-button">
                  <a className="text-blue" href="#">
                    Сохранить
                  </a>
                  <a href="#">Отклонить</a>
                </div>
              </div>
            </div>
            <div className="meeting__message">Моя визитка</div>
            <div className="meeting__author">
              <img
                className="meeting__author-photo"
                src={require("@public/images/stands-contact-1.jpg")}
                alt=""
              />
              <div className="meeting__author-name">Алексей</div>
              <div className="meeting__author-date">13:46 | 14 января 2021</div>
            </div>
            <div className="meeting__message_self">Давай!</div>
            <div className="meeting__message_self">Продолжим общение в&nbsp;видеочате?</div>
            <div className="meeting__me">
              <div className="meeting__me-date">13:46 | 14 января 2021</div>
              <img
                className="meeting__me-photo"
                src={require("@public/images/stands-contact-1.jpg")}
                alt=""
              />
              <div className="meeting__me-name">Евгения</div>
            </div> */}
            {this.state.messages.map((message: any, index: number) => {
              return (
                <>
                  <div
                    className={`meeting__message${
                      message.user.id === this.props.Store.Auth.data?.id ? "_self" : ""
                    }`}
                  >
                    {message.message}
                  </div>
                  {this.state.messages[index + 1]?.user.id === message.user.id ? (
                    <></>
                  ) : (
                    <div
                      className={`meeting${
                        message.user.id === this.props.Store.Auth.data?.id ? "__me" : "__author"
                      }`}
                    >
                      {message.user.avatar ? (
                        <img
                          className={`meeting${
                            message.user.id === this.props.Store.Auth.data?.id ? "__me" : "__author"
                          }-photo`}
                          src={message.user.avatar}
                          alt=""
                        />
                      ) : (
                        <div
                          className={`meeting${
                            message.user.id === this.props.Store.Auth.data?.id ? "__me" : "__author"
                          }-photo`}
                        />
                      )}

                      <div
                        className={`meeting${
                          message.user.id === this.props.Store.Auth.data?.id ? "__me" : "__author"
                        }-name`}
                      >{`${message.user.firstname} ${message.user.lastname}`}</div>
                      <div
                        className={`meeting${
                          message.user.id === this.props.Store.Auth.data?.id ? "__me" : "__author"
                        }-date`}
                      >
                        {moment(message.created_at)
                          .tz("Europe/Moscow")
                          .format("HH:mm | DD MMMM YYYY")}
                      </div>
                    </div>
                  )}
                </>
              );
            })}
            {/* <div className="meeting__services">
              <a href="#">
                <b>Алексей Венгин</b>
              </a>{" "}
              подключил (-а){" "}
              <a href="#">
                <b>Арсений Шабанов</b>
              </a>
              ,{" "}
              <a href="#">
                <b>Светлана Смирнова</b>
              </a>
            </div> */}
          </div>
          <div className="meeting__chat-footer">
            {/* <Link className="meeting__chat-btn" to="#">
              Отправить файл
              <img
                className="meeting__chat-icon"
                src={require("@public/images/btn-file.svg")}
                alt=""
              />
            </Link> */}
            {/* <a className="meeting__chat-btn" href="#">
              Отправить визитку
              <img
                className="meeting__chat-icon"
                src={require("@public/images/btn-file.svg")}
                alt=""
              />
            </a> */}
            <form
              className="form"
              onSubmit={(e) => {
                const message = this.state.message;
                this.state.socket.emit("send-message", { room_id: this.state.room_id, message });
                this.setState({ message: "" });
                e.preventDefault();
              }}
            >
              <div className="form__group">
                <input
                  type="text"
                  placeholder="Напишите сообщение..."
                  value={this.state.message}
                  required={true}
                  onChange={(e) => this.setState({ message: e.target.value })}
                />
                <button type="submit">
                  <img src={require("@public/images/chat-send.svg")} alt="" />
                </button>
              </div>
            </form>
          </div>
          {/* <Chat
                  user_id={this.props.Store.Auth.data.id}
                  user_name={
                    this.props.Store.Auth.data.firstName + " " + this.props.Store.Auth.data.lastName
                  }
                /> */}
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(EventShowPage)
);
